import { render } from "./Setup.vue?vue&type=template&id=b6a11f48&scoped=true"
import script from "./Setup.vue?vue&type=script&lang=js"
export * from "./Setup.vue?vue&type=script&lang=js"

import "./Setup.vue?vue&type=style&index=0&id=b6a11f48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a11f48"]])

export default __exports__